import { createAction, props } from '@ngrx/store';
export const setComplianceReportTypeOption = createAction('[Compliance Report History Page] Set Report Type Option', props());
